import { render } from "./ContactSideBar.vue?vue&type=template&id=50d7a4de&scoped=true"
import script from "./ContactSideBar.vue?vue&type=script&lang=js"
export * from "./ContactSideBar.vue?vue&type=script&lang=js"

import "./ContactSideBar.vue?vue&type=style&index=0&id=50d7a4de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d7a4de"]])

export default __exports__